import { AnimatePresence, motion, useReducedMotion } from "motion/react";

import { useMenu } from "./MenuContext";

export const MenuList: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const prefersReducedMotion = useReducedMotion();
  const { parent, isMenuOpen, isLastOpened, closeMenu } = useMenu();
  return (
    <AnimatePresence>
      {isMenuOpen && (
        <div
          ref={() => {
            const handleKeyDown = (event: KeyboardEvent) => {
              if (event.key === "Escape" && isLastOpened) {
                closeMenu();
              }
            };

            const handleClick = (event: MouseEvent) => {
              if (parent && !event.composedPath().includes(parent)) {
                closeMenu();
              }
            };

            window.addEventListener("click", handleClick);
            window.addEventListener("keydown", handleKeyDown);
            return () => {
              window.removeEventListener("click", handleClick);
              window.removeEventListener("keydown", handleKeyDown);
            };
          }}
        >
          <motion.div
            className="dropdown-content z-20 -mx-1 my-1 min-w-48 rounded-box border bg-base-100 shadow"
            initial={{
              opacity: 0,
              scale: prefersReducedMotion ? 1 : 0.95,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            exit={{
              opacity: 0,
              scale: prefersReducedMotion ? 1 : 0.95,
            }}
          >
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
